import StudyBrowserSort from './StudyBrowserSort';

export default StudyBrowserSort;
